import React from 'react';
import styled from 'styled-components';
import Select from '../Select/SelectFilter';

const NoteFiltersContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
  }

  .row > * {
    flex-basis: 15%;
    margin-right: 13px;
    min-width: 30px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    > div {
      padding: 0;
      height: auto;
    }

    .row {
      flex-direction: column;
      align-items: center;
    }

    .row > div {
      margin-left: 20px;
      margin-top: 10px;
      min-width: 250px;
      width: 80%;
    }
  }
`;

const NoteFilters = ({
  typeFilter,
  vintagesFilter,
  colorFilter,
  appellationFilter,
  rankFilter
}) => (
  <NoteFiltersContainer>
    <div className="row">
      <Select {...typeFilter} />
      <Select {...vintagesFilter} />
      <Select {...colorFilter} />

      <Select {...appellationFilter} />
      <Select {...rankFilter} />
    </div>
  </NoteFiltersContainer>
);

export default NoteFilters;
